import { type IRenderer } from '../types';
import { Console } from './console';

export { Console } from './console';
export const DEFAULT_RENDERERS: IRenderer[] = [new Console()];
